angular
    .module('quattro.bmbo.account.confirm-delete', [
        'quattro.core.alert.service',
        'quattro.core.modal-confirm',
        'quattro.bmbo.account.model',
    ])
    .run(function ($rootScope, myModalService) {

        $rootScope.$on('vq.bmbo.account.delete', function (event, account, callback) {

            callback = callback || angular.noop;

            myModalService.showModal({
                templateUrl: 'bmbo/account/components/confirm-delete/confirm-delete.html',
                controller: 'bmboAccountDeleteConfirmController',
                controllerAs: 'vm',
                inputs: {
                    account: account,
                }
            }).then(function (modal) {
                modal.close.then(callback);
            });

        });
    })
    .controller('bmboAccountDeleteConfirmController', function (close, account, alertService, Account) {

        this.account = account;

        this.cancel = close;

        this.confirm = function () {
            Account
                .cancel(account, (new Date).toISOString().split('T')[0])
                .then(close, function (reason) {
                    alertService.add('error', 'Account konnte nicht geloescht werden.');
                });
        };
    });
